import { render, staticRenderFns } from "./editScheduleClassesDay.vue?vue&type=template&id=56b6fd1c&scoped=true"
import script from "./editScheduleClassesDay.vue?vue&type=script&lang=js"
export * from "./editScheduleClassesDay.vue?vue&type=script&lang=js"
import style0 from "./editScheduleClassesDay.vue?vue&type=style&index=0&id=56b6fd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6fd1c",
  null
  
)

export default component.exports